var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12 " }, [
            _vm.proccess == "START"
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _vm.flow != "mbfacta_recovery"
                    ? _c("b", [
                        _vm._v(
                          "Modifica Preventivo N. " + _vm._s(_vm.item.code)
                        )
                      ])
                    : _c("b", [
                        _vm._v("Modifica Pratica N. " + _vm._s(_vm.item.code))
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull" },
                  [
                    _vm._v(
                      "\r\n          Segui il flusso sotto rappresentato completando le varie fasi richieste.\r\n          "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _vm.flow != "agileenergy" && _vm.flow != "mbfacta_recovery"
                      ? [
                          _vm._v(
                            "\r\n            Questa sezione ti consentira di modificare il Preventivo da stampare o inviare mezzo e-mail al tuo cliente per eventuale successiva accettazione.\r\n          "
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.flow == "agileenergy" ? [_vm._m(0)] : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0!important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      ref: "mainWizard",
                      staticClass: "mt-0 pb-2 formp ",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva preventivo",
                        stepSize: _vm.stepSize,
                        color: _vm.brand == "CHEBONUS" ? "#00917e" : "#cd0c2d",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": function($event) {
                          _vm.flow != "agileenergy"
                            ? _vm.onComplate()
                            : _vm.agilePricePopUp()
                        }
                      }
                    },
                    [
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Seleziona Cessionario Finale",
                            icon: "",
                            "before-change": _vm.validateZeroTab0
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-0v",
                                autocomplete: "qwerqrt23"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row justify-content-center pb-4"
                                },
                                [
                                  _c("div", { staticClass: "col-md-12 " }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "pb-0 center section-heading"
                                      },
                                      [
                                        _vm._v(
                                          "Seleziona il Cessionario Finale "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "center black pb-2" },
                                      [
                                        _vm._v(
                                          "al quale si intende cedere il credito dopo che il Preventivo sarà accettato dal Cliente e convertito in Pratica pagata "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider "
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center text-left mb-4 widthFull flowBoxGrey"
                                    },
                                    [
                                      _c("Flows", {
                                        attrs: { hasSelectButtons: true },
                                        on: {
                                          clicked: _vm.setFlowFromComponent
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 pt-4" }, [
                                    _c(
                                      "p",
                                      { staticClass: "center black pb-0" },
                                      [
                                        _vm._v(
                                          "Se hai bisogno di ulteriori informazioni, contattaci "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "black underline",
                                            attrs: { to: "/contact" }
                                          },
                                          [_vm._v(" QUI ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Seleziona Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-12 " }, [
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pb-3 center section-heading"
                                          },
                                          [
                                            _vm._v(
                                              "Seleziona il Bonus oggetto del Preventivo"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Bonus Casa 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50_hsd.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [_vm._v(" Bonus Casa")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6  col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50_hsd.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/50w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 65%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 65%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/65.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/65w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 65%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/65_hsd.png")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: require("../../assets/images/65w.png")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{required:true, max: 63, min: 2}"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le quattro icone sopraindicate. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-12 center" },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "pb-3 center section-heading pb-1 mb-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "Inserisci Valore Nominale di Cessione che verrà calcolato nel Preventivo "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  " Es. se dal Cessionario Finale viene trattenuto il 20% del valore di Cessione, inserire il Valore Nominale pari all'80 %   "
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 pb-4 center"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.fin_cost,
                                                    expression: "fin_cost"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max_value: 90,
                                                      min_value: 50
                                                    },
                                                    expression:
                                                      "{required:true, max_value: 90, min_value: 50}"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.fin_cost"
                                                  ),
                                                  valid: !!_vm.fin_cost
                                                },
                                                attrs: {
                                                  type: "number",
                                                  id: "fin_cost",
                                                  name: "fin_cost",
                                                  placeholder: "Es: 80",
                                                  "data-vv-as": "finCost"
                                                },
                                                domProps: {
                                                  value: _vm.fin_cost
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.fin_cost =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "inputLabel" },
                                                [_vm._v(" % ")]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 mb-3 center"
                                            },
                                            [
                                              _vm.errors.has("form-0.fin_cost")
                                                ? _c(
                                                    "div",
                                                    { staticClass: "red" },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "h5 red mt-3 pt-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Per procedere devi inserire Valore Nominale di Cessione. "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            " ( range valori dal 50% al 90% )"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Inserisci Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                    Inserisci i dati del cliente finale\r\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-3 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.client_type,
                                                          expression:
                                                            "client_type"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 63,
                                                            min: 2
                                                          },
                                                          expression:
                                                            "{required:true, max: 63, min: 2}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.client_type"
                                                        ),
                                                        valid: !!_vm.client_type
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "randomq",
                                                        id: "client_type",
                                                        name: "client_type",
                                                        "data-vv-as":
                                                          "Tipologia cliente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.client_type = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Persona fisica"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Persona fisica"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.ecoBonus !=
                                                      "Bonus Casa 50%"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  "Partita IVA"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Partita IVA"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Amministratore di condominio"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Condominio (Amministratore)"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_type"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Tipologia cliente"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_type"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_type"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.client_owner_type,
                                                          expression:
                                                            "client_owner_type"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 123,
                                                            min: 2
                                                          },
                                                          expression:
                                                            "{required:true, max: 123, min: 2}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.client_owner_type"
                                                        ),
                                                        valid: !!_vm.client_owner_type
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "randomq",
                                                        id: "client_owner_type",
                                                        name:
                                                          "client_owner_type",
                                                        "data-vv-as":
                                                          "Titolo di possesso"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.client_owner_type = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Proprietario o comproprietario"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Proprietario o comproprietario"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Detentore o co-detentore"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Detentore o co-detentore (es. locatario, comodatario, usufruttuario, ecc.)"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Familiare convivente"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Familiare convivente con il possessore o con il detentore"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Amministratore di condominio"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  "Condominio"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Condominio"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_owner_type"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Titolo di possesso / diritto reale"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_owner_type"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_owner_type"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.client_owner_type !=
                                            "Proprietario o comproprietario" &&
                                          _vm.client_owner_type != ""
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-5 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.client_owner_codice_fiscale,
                                                            expression:
                                                              "client_owner_codice_fiscale"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: false,
                                                              partitaIva:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length == 11
                                                                  ? true
                                                                  : false,
                                                              codiceFiscale:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length == 16
                                                                  ? true
                                                                  : false,
                                                              max:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length < 11
                                                                  ? 16
                                                                  : 16,
                                                              min:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length > 11
                                                                  ? 16
                                                                  : 11
                                                            },
                                                            expression:
                                                              "{required:false, partitaIva: client_owner_codice_fiscale.length == 11 ? true : false, codiceFiscale: client_owner_codice_fiscale.length == 16 ? true : false, max: client_owner_codice_fiscale.length < 11 ? 16 : 16, min: client_owner_codice_fiscale.length > 11 ? 16 : 11}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-1.client_owner_codice_fiscale"
                                                          ),
                                                          valid: !!_vm.client_owner_codice_fiscale
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          "data-vv-validate-on":
                                                            "blur",
                                                          id:
                                                            "client_owner_codice_fiscale",
                                                          name:
                                                            "client_owner_codice_fiscale",
                                                          "data-vv-as":
                                                            "P.IVA o codice fiscale del proprietario"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.client_owner_codice_fiscale
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.client_owner_codice_fiscale =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for:
                                                              "client_owner_codice_fiscale"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " P.Iva o Codice Fiscale "
                                                          ),
                                                          _c("small", [
                                                            _vm._v(
                                                              " del proprietario dell'immobile "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "se non disponibile, potrai inserirlo in fase di conferma del preventivo"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-1.client_owner_codice_fiscale"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                      " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-1.client_owner_codice_fiscale"
                                                                    )
                                                                  ) +
                                                                  "\r\n                    "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                    "Partita IVA",
                                                  expression:
                                                    "client_type == 'Partita IVA'"
                                                }
                                              ],
                                              staticClass: "col-md-8 mb-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_ragione_sociale,
                                                        expression:
                                                          "client_ragione_sociale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                            "Partita IVA"
                                                              ? true
                                                              : false,
                                                          max: 128,
                                                          min: 5
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Partita IVA' ) ? true : false, max: 128, min: 5}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_ragione_sociale"
                                                      ),
                                                      valid: !!_vm.client_ragione_sociale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id:
                                                        "client_ragione_sociale",
                                                      name:
                                                        "client_ragione_sociale",
                                                      "data-vv-as":
                                                        "Ragione Sociale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_ragione_sociale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_ragione_sociale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_ragione_sociale"
                                                      }
                                                    },
                                                    [_vm._v("Ragione Sociale")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_ragione_sociale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_ragione_sociale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row " },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.clientLastname,
                                                        expression:
                                                          "clientLastname"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.clientLastname"
                                                      ),
                                                      valid: !!_vm.clientLastname
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "clientLastname",
                                                      name: "clientLastname",
                                                      "data-vv-as": "Cognome"
                                                    },
                                                    domProps: {
                                                      value: _vm.clientLastname
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.clientLastname =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "clientLastname"
                                                      }
                                                    },
                                                    [_vm._v("Cognome")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.clientLastname"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.clientLastname"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.clientName,
                                                        expression: "clientName"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.clientName"
                                                      ),
                                                      valid: !!_vm.clientName
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "clientName",
                                                      name: "clientName",
                                                      "data-vv-as": "Nome"
                                                    },
                                                    domProps: {
                                                      value: _vm.clientName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.clientName =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "clientName"
                                                      }
                                                    },
                                                    [_vm._v("Nome")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.clientName"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.clientName"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3 " },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_email,
                                                        expression:
                                                          "client_email"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          email: true,
                                                          temporaryEmail: true,
                                                          plusIssueEmail: true,
                                                          max: 56
                                                        },
                                                        expression:
                                                          "{required:true, email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                                      }
                                                    ],
                                                    ref: "client_email",
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_email"
                                                      ),
                                                      valid: !!_vm.client_email
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_email",
                                                      name: "client_email",
                                                      "data-vv-as": "Email"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_email =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_email"
                                                      }
                                                    },
                                                    [_vm._v("Email* ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_email"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_email"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_phone,
                                                        expression:
                                                          "client_phone"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: _vm.client_mobile
                                                            ? false
                                                            : true,
                                                          max: 12,
                                                          min: 8,
                                                          regex: /^[0]+/
                                                        },
                                                        expression:
                                                          "{required: client_mobile ? false : true, max: 12, min: 8, regex: /^[0]+/}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_phone"
                                                      ),
                                                      valid: !!_vm.client_phone
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_phone",
                                                      name: "client_phone",
                                                      "data-vv-as": "Telefono"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_phone
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_phone =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_phone"
                                                      }
                                                    },
                                                    [_vm._v("Telefono ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_phone"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_phone"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_mobile,
                                                        expression:
                                                          "client_mobile"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: _vm.client_phone
                                                            ? false
                                                            : true,
                                                          max: 12,
                                                          min: 8,
                                                          regex: /^[3]+/
                                                        },
                                                        expression:
                                                          "{required: client_phone ? false : true, max: 12, min: 8, regex: /^[3]+/}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_mobile"
                                                      ),
                                                      valid: !!_vm.client_mobile
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_mobile",
                                                      name: "client_mobile",
                                                      "data-vv-as": "Cellulare"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_mobile
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_mobile =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_mobile"
                                                      }
                                                    },
                                                    [_vm._v("Cellulare ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_mobile"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_mobile"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                      "Persona fisica" ||
                                                    _vm.client_type ==
                                                      "Amministratore di condominio",
                                                  expression:
                                                    "client_type == 'Persona fisica' || client_type == 'Amministratore di condominio'"
                                                }
                                              ],
                                              staticClass: "col-md-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_codice_fiscale,
                                                        expression:
                                                          "client_codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                              "Persona fisica" ||
                                                            _vm.client_type ==
                                                              "Amministratore di condominio"
                                                              ? true
                                                              : false,
                                                          codiceFiscale: true,
                                                          max: 16,
                                                          min: 16
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Persona fisica' || client_type == 'Amministratore di condominio' ) ? true : false, codiceFiscale: true,  max: 16, min: 16}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_codice_fiscale"
                                                      ),
                                                      valid: !!_vm.client_codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id:
                                                        "client_codice_fiscale",
                                                      name:
                                                        "client_codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_codice_fiscale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_codice_fiscale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_codice_fiscale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                    "Partita IVA",
                                                  expression:
                                                    "client_type == 'Partita IVA'"
                                                }
                                              ],
                                              staticClass: "col-md-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_partita_iva,
                                                        expression:
                                                          "client_partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                            "Partita IVA"
                                                              ? true
                                                              : false,
                                                          partitaIva: true,
                                                          max: 11,
                                                          min: 11
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Partita IVA' ) ? true : false, partitaIva: true, max: 11, min: 11}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_partita_iva"
                                                      ),
                                                      valid: !!_vm.client_partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_partita_iva",
                                                      name:
                                                        "client_partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_partita_iva =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_partita_iva"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_partita_iva"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.flow == "agileenergy" ||
                                          _vm.flow == "mbfacta_recovery"
                                            ? _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _vm.client_type !=
                                                  "Partita IVA"
                                                    ? _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull center black pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                   Indirizzo di residenza del cliente finale\r\n                 "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull center black pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                   Indirizzo Sede Legale\r\n                 "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (_vm.flow == "agileenergy" ||
                                            _vm.flow == "mbfacta_recovery") &&
                                          _vm.addressLoaded
                                            ? _c("Address", {
                                                attrs: {
                                                  keyAssigned: "1",
                                                  parseAdress:
                                                    _vm.parse_client_address,
                                                  parseCivic:
                                                    _vm.parse_client_civic,
                                                  parseProvince:
                                                    _vm.parse_client_province,
                                                  parseCity:
                                                    _vm.parse_client_city,
                                                  parseZip: _vm.parse_client_zip
                                                },
                                                on: {
                                                  setProvince:
                                                    _vm.setProvinceResidence,
                                                  setCity: _vm.setCityResidence,
                                                  setZip: _vm.setZipResidence,
                                                  setAddress:
                                                    _vm.setAddressResidence,
                                                  setCivic:
                                                    _vm.setCivicResidence
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Bonus Casa 50%"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-12 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-check"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label widthFull black h5",
                                                              attrs: {
                                                                for:
                                                                  "usoAbitativo"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                        L'immobile oggetto dell'intervento è a prevalente uso abitativo?\r\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check form-check-inline mt-2"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo = 1
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.usoAbitativo,
                                                                        expression:
                                                                          "usoAbitativo"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|included:1,0",
                                                                        expression:
                                                                          "'required|included:1,0'"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-check-input inline mr-3",
                                                                    class: {
                                                                      "is-invalid": _vm.errors.has(
                                                                        "form-1.usoAbitativo"
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "radio",
                                                                      value:
                                                                        "1",
                                                                      name:
                                                                        "usoAbitativo"
                                                                    },
                                                                    domProps: {
                                                                      checked: _vm._q(
                                                                        _vm.usoAbitativo,
                                                                        "1"
                                                                      )
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.usoAbitativo =
                                                                          "1"
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c("b", [
                                                                    _vm._v("SI")
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check form-check-inline"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo = 0
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.usoAbitativo,
                                                                        expression:
                                                                          "usoAbitativo"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-check-input inline mr-3",
                                                                    class: {
                                                                      "is-invalid": _vm.errors.has(
                                                                        "form-1.usoAbitativo"
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "radio",
                                                                      value:
                                                                        "0",
                                                                      name:
                                                                        "usoAbitativo"
                                                                    },
                                                                    domProps: {
                                                                      checked: _vm._q(
                                                                        _vm.usoAbitativo,
                                                                        "0"
                                                                      )
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.usoAbitativo =
                                                                          "0"
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c("b", [
                                                                    _vm._v("NO")
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "form-1.usoAbitativo"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('form-1.usoAbitativo')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "errorMes red"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                        Il servizio deve essere accettato oppure rifiutato\r\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black pb-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                    Inserisci l'indirizzo dell'immobile oggetto dell'intervento\r\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.addressLoaded
                                            ? _c("Address", {
                                                attrs: {
                                                  keyAssigned: "2",
                                                  parseAdress: _vm.parse_adress,
                                                  parseCivic: _vm.parse_civic,
                                                  parseProvince:
                                                    _vm.parse_province,
                                                  parseCity: _vm.parse_city,
                                                  parseZip: _vm.parse_zip
                                                },
                                                on: {
                                                  setProvince:
                                                    _vm.setProvinceBuilding,
                                                  setCity: _vm.setCityBuilding,
                                                  setZip: _vm.setZipBuilding,
                                                  setAddress:
                                                    _vm.setAddressBuilding,
                                                  setCivic: _vm.setCivicBuilding
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider"
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    LISTA DOCUMENTI\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title:
                              _vm.flow == "mbfacta_recovery"
                                ? "Inserisci Valori"
                                : "Compila il Preventivo",
                            icon: "",
                            "before-change": _vm.validateSecondTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull orangeBg",
                              attrs: {
                                "data-vv-scope": "form-2",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _vm.bonusError
                                    ? _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.bonusError
                                    ? _c("div", { staticClass: "col-md-12" }, [
                                        _c("h4", {
                                          staticClass: "widthFull center red",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.bonusErrorText
                                            )
                                          }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEdilLiberaSelect &&
                                  _vm.flow != "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pb-5"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    L'intervento è di edilizia libera* ?\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("* Vedi  "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "green underline",
                                                attrs: {
                                                  href:
                                                    "https://storage.googleapis.com/chebonus/glossario_edilizia_libera.pdf",
                                                  target: "_blank"
                                                }
                                              },
                                              [_c("b", [_vm._v(" glossario ")])]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "1"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "yes"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Si ")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "2"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "no"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" No ")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEdilLiberaSelect &&
                                  _vm.flow == "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pb-5"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black red"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    Agile Energy accetta solo interventi di edilizia libera con Totale Quota Spesa Agevolabile ≤ € 15.000 IVA incl. e interventi di non edilizia libera con Totale Quota Spesa Agevolabile ≤ € 10.000 IVA incl.\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    L'intervento è di edilizia libera* ?\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("* Vedi  "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "green underline",
                                                attrs: {
                                                  href:
                                                    "https://storage.googleapis.com/chebonus/glossario_edilizia_libera.pdf",
                                                  target: "_blank"
                                                }
                                              },
                                              [_c("b", [_vm._v(" glossario ")])]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "1"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "yes"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Si ")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\r\n                    Inserisci la Tipologia di intervento\r\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "group custInput",
                                        class: {
                                          inputHSD: _vm.brand == "HAPPYBONUS"
                                        }
                                      },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.eventType,
                                                expression: "eventType"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{required:true, max: 63, min: 2}"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-2.eventType"
                                              ),
                                              valid: !!_vm.eventType
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "eventType",
                                              name: "eventType",
                                              "data-vv-as": "Tipo di intervento"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.eventType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "sostituzione" }
                                              },
                                              [_vm._v("Sostituzione")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "Instalazione" }
                                              },
                                              [_vm._v("Nuova Installazione")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "eventType" }
                                          },
                                          [_vm._v("Tipologia di intervento")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-2.eventType")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                      " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-2.eventType"
                                                      )
                                                    ) +
                                                    "\r\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\r\n                    Inserisci i Beni Significativi ( prodotti, sistemi )\r\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "widthFull" },
                                        _vm._l(_vm.products, function(
                                          elem,
                                          num
                                        ) {
                                          return _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: elem.group,
                                                              expression:
                                                                "elem.group"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{required:true, is_not:''}"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.g" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.group
                                                          },
                                                          attrs: {
                                                            id:
                                                              "g" + elem.index,
                                                            name:
                                                              "g" + elem.index,
                                                            "data-vv-as":
                                                              "Gruppo"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "group",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setGroup(
                                                                  elem.index
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _vm.ecoBonus ==
                                                          "Ecobonus 50%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value ==
                                                                      "condensazione"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : _vm.ecoBonus ==
                                                              "Ecobonus 65%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value !=
                                                                      "tradizionale"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "group"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli gruppo prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.g" + elem.index
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.g" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull  black pointer m-0",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.insertProductCode(
                                                                elem.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "search",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.insertProductCode(
                                                                    elem.index
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              "o cerca con codice prodotto "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-5" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      elem.group != "ibridi" &&
                                                      elem.group !=
                                                        "altroVaillant" &&
                                                      _vm.flow !=
                                                        "mbfacta_recovery"
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{required:true, is_not:''}"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.Modello
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : elem.group ==
                                                            "altroVaillant" ||
                                                          _vm.flow ==
                                                            "mbfacta_recovery"
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product
                                                                    .name,
                                                                expression:
                                                                  "elem.product.name"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  is_not: ""
                                                                },
                                                                expression:
                                                                  "{required:true, is_not:''}"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.p" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id:
                                                                "p" +
                                                                elem.index,
                                                              name:
                                                                "p" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Prodotto"
                                                            },
                                                            domProps: {
                                                              value:
                                                                elem.product
                                                                  .name
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              },
                                                              click:
                                                                _vm.checkIfEmpty,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  elem.product,
                                                                  "name",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{required:true, is_not:''}"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      selected:
                                                                        item.Modello ==
                                                                        elem
                                                                          .product
                                                                          .name,
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\r\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item.ModelloPompaDiCalore
                                                                        ) +
                                                                        " + " +
                                                                        _vm._s(
                                                                          item.ModelloCaldaiaACondensazione
                                                                        ) +
                                                                        "\r\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "product"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli Prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ) && !elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.p" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            Prima scegli gruppo\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mr-md-0 pr-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.quantity,
                                                            expression:
                                                              "elem.quantity"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0",
                                                              min_value: 1,
                                                              max: 4
                                                            },
                                                            expression:
                                                              "{required:true, is_not:'0', min_value: 1, max:4}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.q" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.quantity
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          id:
                                                            "q" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "q" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Quantità"
                                                        },
                                                        domProps: {
                                                          value: elem.quantity
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.calcTotalPriceProducts()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "quantity",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Quantità")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.q" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 pl-md-0 ml-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.price,
                                                            expression:
                                                              "elem.price"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0"
                                                            },
                                                            expression:
                                                              "{required:true, is_not:'0', }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.i" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.price
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id:
                                                            "i" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "i" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Importo"
                                                        },
                                                        domProps: {
                                                          value: elem.price
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.formatPrice(
                                                              elem.index
                                                            ),
                                                              _vm.calcTotalPriceProducts()
                                                          },
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.keymonitor(
                                                              $event,
                                                              elem.index,
                                                              "prod"
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Importo €")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "widthFull center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                            (IVA esclusa)\r\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.i" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "removeProduct pointer",
                                                      class: elem.index
                                                    },
                                                    [
                                                      num != 0
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "trash-alt",
                                                                size: "lg"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeProduct(
                                                                    num
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: { click: _vm.addProduct }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: { click: _vm.addProduct }
                                                }),
                                                _vm._v(
                                                  " Aggiungi Beni Significativi\r\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo Beni Significativi (IVA esclusa): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(_vm.totalProducts) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                        Inserisci altri Beni e/o Accessori opzionali\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.accessories, function(
                                        elem,
                                        num
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "row accRow" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.group,
                                                            expression:
                                                              "elem.group"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {},
                                                            expression: "{}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.ac" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.group
                                                        },
                                                        attrs: {
                                                          id: "ac" + elem.index,
                                                          name:
                                                            "ac" + elem.index,
                                                          "data-vv-as":
                                                            "accessori opzionali"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "group",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setTypeAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessori,
                                                        function(item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected:
                                                                  "selected"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "group" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Scegli accessori opzionali"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ac" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ac" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "widthFull  black pointer m-0",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.insertAccessoriesCode(
                                                              elem.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "search",
                                                              size: "sm"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.insertAccessoriesCode(
                                                                  elem.index
                                                                )
                                                              }
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "o cerca con codice accessorio "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-7" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    elem.group ==
                                                      "termoregolazione" &&
                                                    _vm.flow !=
                                                      "mbfacta_recovery"
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product,
                                                                expression:
                                                                  "elem.product"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required:
                                                                    elem.group !=
                                                                    ""
                                                                },
                                                                expression:
                                                                  "{required: elem.group != ''}"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.ap" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              id:
                                                                "ap" +
                                                                elem.index,
                                                              name:
                                                                "ap" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Accessorio"
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    elem,
                                                                    "product",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setAccessories(
                                                                    elem.index
                                                                  )
                                                                }
                                                              ],
                                                              click:
                                                                _vm.checkIfEmpty
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .itemsAccessories[
                                                              elem.index
                                                            ],
                                                            function(
                                                              item,
                                                              ind
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value: {
                                                                      index: ind,
                                                                      name:
                                                                        item.Modello,
                                                                      serial:
                                                                        item.codice
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Modello
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product
                                                                  .name,
                                                              expression:
                                                                "elem.product.name"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required:
                                                                  elem.group !=
                                                                  "",
                                                                max: 128
                                                              },
                                                              expression:
                                                                "{required: elem.group != '' , max: 128}"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.ap" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem
                                                              .product.name
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            id:
                                                              "ap" + elem.index,
                                                            name:
                                                              "ap" + elem.index,
                                                            "data-vv-as":
                                                              "Accessorio"
                                                          },
                                                          domProps: {
                                                            value:
                                                              elem.product.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                elem.product,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Scegli Accessorio"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Inserisci Accessorio"
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ) && !elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ap" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          Prima scegli tipo\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.destination,
                                                            expression:
                                                              "elem.destination"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required:
                                                                elem.group != ""
                                                            },
                                                            expression:
                                                              "{required: elem.group != ''}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.act" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.destination
                                                        },
                                                        attrs: {
                                                          id:
                                                            "act" + elem.index,
                                                          name:
                                                            "act" + elem.index,
                                                          "data-vv-as":
                                                            "destinazione dell'accessorio"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "destination",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setDestinationAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessoriDestination,
                                                        function(item) {
                                                          return _vm.groupsAccessoriDestination
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      item.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "destination"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Seleziona destinazione dell'accessorio per calcolo massimale MITE"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("small"),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.act" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.act" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 mr-md-0 pr-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.quantity,
                                                          expression:
                                                            "elem.quantity"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0",
                                                            min_value: 1,
                                                            max: 4
                                                          },
                                                          expression:
                                                            "{required: elem.group != '', is_not:'0', min_value: 1, max:4}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.aq" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.quantity
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        id:
                                                          "aq" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "aq" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Quantità"
                                                      },
                                                      domProps: {
                                                        value: elem.quantity
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.calcTotalPriceAccessories()
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "quantity",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Quantità")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.aq" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.aq" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 pl-md-0 ml-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.price,
                                                          expression:
                                                            "elem.price"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0"
                                                          },
                                                          expression:
                                                            "{required: elem.group != '', is_not:'0', }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.ai" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.price
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id:
                                                          "ai" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "ai" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Importo"
                                                      },
                                                      domProps: {
                                                        value: elem.price
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.formatPriceAccessories(
                                                            elem.index
                                                          )
                                                          _vm.calcTotalPriceAccessories()
                                                        },
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          return _vm.keymonitor(
                                                            $event,
                                                            elem.index,
                                                            "accs"
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "price",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Importo €")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "widthFull center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                          (IVA esclusa)\r\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ai" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ai" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "removeProduct pointer",
                                                    class: elem.index
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAccessories(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: {
                                                  click: _vm.addAccessories
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: {
                                                    click: _vm.addAccessories
                                                  }
                                                }),
                                                _vm._v(
                                                  " Aggiungi altri Beni e/o Accessori opzionali\r\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo accessori opzionali (IVA esclusa): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAccessories) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                        Installazione/posa in opera\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput",
                                                class: {
                                                  inputHSD:
                                                    _vm.brand == "HAPPYBONUS"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceWork,
                                                      expression: "priceWork"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceWork"
                                                    ),
                                                    valid: !!_vm.priceWork
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceWork",
                                                    name: "priceWork",
                                                    "data-vv-as":
                                                      "Importo installazione/posa in opera"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceWork
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceWork()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceWork =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceWork" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera ( IVA esclusa )"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceWork"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceWork"
                                                              )
                                                            ) +
                                                            "\r\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale installazione/posa in opera ( importo € IVA esclusa ): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(_vm.priceWork) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.dl == "new" || _vm.priceAT != "0,00"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                                          Inserisci l'eventuale importo dell'asseverazione della congruità delle spese rilasciata da un tuo tecnico abilitato "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " se il totale importo spesa agevolabile > " +
                                                          _vm._s(_vm.tqsa) +
                                                          " IVA incl.\r\n                                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                                          Il documento di asseverazione della congruità delle spese dovrà essere richiesto\r\n                                          direttamente da parte dall’aderente " +
                                                          _vm._s(_vm.brand) +
                                                          " ad un professionista tecnico\r\n                                          abilitato, dopodiché caricato dall’aderente " +
                                                          _vm._s(_vm.brand) +
                                                          " nel set documentale della\r\n                                          Pratica " +
                                                          _vm._s(_vm.brand) +
                                                          "\r\n\r\n                                        "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.priceAT,
                                                            expression:
                                                              "priceAT"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceAT"
                                                          ),
                                                          valid: !!_vm.priceAT
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceAT",
                                                          name: "priceAT",
                                                          "data-vv-as":
                                                            "Costo dell'asseverazione della congruità delle spese"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceAT
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceAT()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceAT =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceAT"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo dell'asseverazione della congruità delle spese"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceAT"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceAT"
                                                                    )
                                                                  ) +
                                                                  "\r\n                                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-md-6 mb-3"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Inserisci l'eventuale importo della Visura Catastale dell'immobile oggetto dell'intervento\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.flow != "mbfacta_recovery"
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        - Se il cliente dispone di una Visura Catastale aggiornata dell'immobile oggetto dell'intervento, inserisci € 0 nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri procurare autonomamente la Visura Catastale dell'immobile oggetto dell'intervento per il tuo cliente, inserisci l'importo che vuoi addebitargli nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri usufruire del nostro servizio opzionale a pagamento per il recupero della Visura Catastale dell'immobile oggetto dell'intervento, seleziona \"ACCETTO\" nella sezione sotto riportata e inserisci l'importo che\r\n                        vuoi addebitargli nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n\r\n\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.priceDcast,
                                                            expression:
                                                              "priceDcast"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceDcast"
                                                          ),
                                                          valid: !!_vm.priceDcast
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceDcast",
                                                          name: "priceDcast",
                                                          "data-vv-as":
                                                            "Costo recupero dei dati catastali dell'immobile"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceDcast
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceDcast()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceDcast =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceDcast"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo recupero dei dati catastali dell'immobile"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceDcast"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                          " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceDcast"
                                                                    )
                                                                  ) +
                                                                  "\r\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.flow != "mbfacta_recovery"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-6 mb-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label widthFull black h5",
                                                                  attrs: {
                                                                    for:
                                                                      "datiCatastali"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Servizio opzionale a pagamento di recupero "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      '"Visura Catastale"'
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " dell'immobile oggetto dell'intervento al costo di €10 +IVA\r\n                            "
                                                                  ),
                                                                  _c("small", [
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "( importo che ti sarà addebitato in fase di pagamento Pratica se accetti il servizio )"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline mt-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.datiCatastali = 1
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.datiCatastali,
                                                                              expression:
                                                                                "datiCatastali"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-1.datiCatastali"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "1",
                                                                            name:
                                                                              "datiCatastali"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.datiCatastali,
                                                                              "1"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.datiCatastali =
                                                                                "1"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.datiCatastali = 0
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.datiCatastali,
                                                                              expression:
                                                                                "datiCatastali"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-1.datiCatastali"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "0",
                                                                            name:
                                                                              "datiCatastali"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.datiCatastali,
                                                                              "0"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.datiCatastali =
                                                                                "0"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "NON ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "form-1.datiCatastali"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('form-1.datiCatastali')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "errorMes red"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Il servizio deve essere accettato oppure rifiutato\r\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      !_vm.NoEnea && _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Inserisci l'eventuale importo della Pratica ENEA dell'intervento\r\n\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "center widthFull Bold"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          'Attenzione! Questa sezione "Pratica ENEA" è relativa solo ad impianti con potenza nominale ≤ 100 kW. '
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(
                                                        "Per impianti con potenza nominale > 100 kW consulta il tuo progettista/tecnico abilitato\r\n\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.flow != "mbfacta_recovery"
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-left widthFull "
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        - Se il cliente ti fornisce la Pratica ENEA con il codice CPID e la ricevuta dell'avvenuta trasmissione all'ENEA inserisci € 0 nel campo \"Costo Gestione Pratica ENEA\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri produrre autonomamente la Pratica ENEA con il codice CPID e la ricevuta dell'avvenuta trasmissione all'ENEA inserisci l'importo che vuoi addebitargli nel campo \"Costo Gestione Pratica ENEA\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri usufruire del nostro servizio opzionale a pagamento per il redazione e invio della "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              '"Pratica ENEA"'
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            ' dell\'intervento seleziona "ACCETTO" nella sezione sotto riportata e inserisci l\'importo che vuoi\r\n                        addebitargli nel campo "Costo Gestione Pratica ENEA"\r\n                      '
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.priceEnea,
                                                            expression:
                                                              "priceEnea"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceEnea"
                                                          ),
                                                          valid: !!_vm.priceEnea
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceEnea",
                                                          name: "priceEnea",
                                                          "data-vv-as":
                                                            "Costo Gestione Pratica ENEA"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceEnea
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceEnea()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceEnea =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceEnea"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo Gestione Pratica ENEA"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceEnea"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                          " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceEnea"
                                                                    )
                                                                  ) +
                                                                  "\r\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.flow != "mbfacta_recovery"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-6 mb-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label widthFull black h5",
                                                                  attrs: {
                                                                    for:
                                                                      "datiCatastali"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Servizio opzionale a pagamento di redazione e invio "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      '"Pratica ENEA"'
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " dell'intervento al costo di €50 +IVA\r\n                            "
                                                                  ),
                                                                  _c("small", [
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "( importo che ti sarà addebitato in fase di pagamento Pratica se accetti il servizio )"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline mt-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.enea = 1
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.enea,
                                                                              expression:
                                                                                "enea"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-2.enea"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "1",
                                                                            name:
                                                                              "enea"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.enea,
                                                                              "1"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.enea =
                                                                                "1"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.enea = 0
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.enea,
                                                                              expression:
                                                                                "enea"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-2.enea"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "0",
                                                                            name:
                                                                              "enea"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.enea,
                                                                              "0"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.enea =
                                                                                "0"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "NON ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "form-2.enea"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('form-2.enea')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "errorMes red"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Il servizio deve essere accettato oppure rifiutato\r\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo (IVA esclusa):\r\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "\r\n                        €\r\n                        " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceDcast
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                    "\r\n\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si" &&
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-2 pb-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Gestione Aliquote IVA degli importi indicati nelle sezioni del Preventivo\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Beni significativi ( quota concorrente accessori e manodopera )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_lavoro,
                                                          expression:
                                                            "iva_age_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_age_lavoro
                                                      },
                                                      attrs: {
                                                        id: "iva_age_lavoro",
                                                        name: "iva_age_lavoro",
                                                        "data-vv-as":
                                                          "Beni significativi, quota concorrente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Beni significativi ( quota eccedente accessori e manodopera )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_extra,
                                                          expression:
                                                            "iva_age_extra"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_extra"
                                                        ),
                                                        valid: !!_vm.iva_age_extra
                                                      },
                                                      attrs: {
                                                        id: "iva_age_extra",
                                                        name: "iva_age_extra",
                                                        "data-vv-as":
                                                          "Beni significativi, quota eccedente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_extra = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Altri Beni / Accessori opzionali / Installazione e Posa in Opera\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_accessori_lavoro,
                                                          expression:
                                                            "iva_accessori_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_accessori_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_accessori_lavoro
                                                      },
                                                      attrs: {
                                                        id:
                                                          "iva_accessori_lavoro",
                                                        name:
                                                          "iva_accessori_lavoro",
                                                        "data-vv-as":
                                                          "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_accessori_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Altri oneri ( costo Visura Catastale, costo Pratica ENEA, costo Pratica cessione )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_altri_oneri,
                                                          expression:
                                                            "iva_altri_oneri"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_altri_oneri"
                                                        ),
                                                        valid: !!_vm.iva_altri_oneri
                                                      },
                                                      attrs: {
                                                        id: "iva_altri_oneri",
                                                        name: "iva_altri_oneri",
                                                        "data-vv-as":
                                                          "Altri oneri per il Committente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_altri_oneri = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.client_type ==
                                                "Persona fisica" &&
                                              _vm.usoAbitativo == 1 &&
                                              (_vm.iva_altri_oneri == "0.04" ||
                                                _vm.iva_accessori_lavoro ==
                                                  "0.04" ||
                                                _vm.iva_age_extra == "0.04" ||
                                                _vm.iva_age_lavoro == "0.04")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 mb-3 center text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "Bold center"
                                                        },
                                                        [_vm._v("Attenzione! ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          "Non tutti gli acquisti e interventi, a prescindere, possono essere considerati secondo l’aliquota agevolata al 4% bensì esclusivamente quelli prettamente collegati alla specifica disabilità del cliente finale. "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _c("br"),
                                                      _c(
                                                        "b",
                                                        { staticClass: "red" },
                                                        [
                                                          _vm._v(
                                                            "Occorre, pertanto, verificare la tipologia di intervento da eseguire per verificare se il cliente potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mt-2 center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Consulta la "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "Bold underline black",
                                                              attrs: {
                                                                href:
                                                                  "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [_vm._v("guida")]
                                                          ),
                                                          _vm._v(
                                                            " relativa alle\r\n                        agevolazioni fiscali per le persone con disabilità. "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _vm.requiredOperations
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 mb-3 requiredCont"
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "green " },
                                                  [
                                                    _vm._v(
                                                      "Requisiti tecnici richiesti per aderire al bonus:"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("h5", {
                                                  staticClass: "black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.requiredOperations
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title:
                              _vm.flow == "mbfacta_recovery"
                                ? "Pratica Completata"
                                : "Preventivo completato",
                            subtitle: "Tutti i campi sono obbligatori",
                            icon: "",
                            "before-change": _vm.validateThirdTab
                          }
                        },
                        [
                          _vm.calcFinish
                            ? _c(
                                "form",
                                {
                                  staticClass: "widthFull orio pt-3 pr-md-3",
                                  attrs: {
                                    "data-vv-scope": "form-3",
                                    autocomplete: "qwerqrt3"
                                  }
                                },
                                [
                                  _vm.bonusError
                                    ? _c("div", { staticClass: "widthFull" }, [
                                        _vm.bonusError
                                          ? _c("div", {
                                              staticClass:
                                                "row justify-content-center divider"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.bonusError
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c("h4", {
                                                  staticClass:
                                                    "widthFull center red",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.bonusErrorText
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.flow == "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "widthFull yellowBg  pb-4"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider fordelete"
                                          }),
                                          _vm._v(" "),
                                          !_vm.agileDiscount
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass: "pt-4 yellowBg"
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Il costo di gestione del Servizio del General Contractor AGILE ENERGY a supporto della gestione di questa Pratica è pari a: "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b",
                                                    { staticClass: "green" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.priceAgileenergy
                                                            )
                                                          ) +
                                                          "  ( IVA escl. )"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                { staticClass: "pt-4 " },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                  Il costo di gestione del Servizio del General Contractor AGILE ENERGY a supporto della gestione di questa Pratica è pari a:\r\n                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull center green"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                (_vm.priceAgileenergy /
                                                                  70) *
                                                                100
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                          "\r\n                    - Sconto 30% = € " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.priceAgileenergy
                                                            )
                                                          ) +
                                                          " ( IVA escl. )\r\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c("small", {}, [
                                            _vm._v(
                                              "\r\n                Questo costo non è incluso in questo Preventivo, pertanto l'installatore professionista in subappalto ad AGILE ENERGY\r\n                 riceverà la relativa fattura da AGILE ENERGY in compensazione\r\n                 della fattura che l'installatore professionista in subappalto emetterà ad AGILE ENERGY per il materiale\r\n                 e l'installazione, come indicati nel Preventivo.\r\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("br")
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      ref: "invoiceData",
                                      staticClass: "widthFull"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider fordelete"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 mt-4"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Cessionario/prestatore (fornitore)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .partita_iva
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .azienda
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Indirizzo: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .indirizzo
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .civico
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Comune: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .comune
                                                            ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .provincia
                                                              ) +
                                                              ")"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("CAP: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile.cap
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .email
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .cellulare
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "IBAN:\r\n                          "
                                                        ),
                                                        _vm.flow == "poste"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow == "cdp"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban_cdp
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow ==
                                                              "mbfacta" ||
                                                            _vm.flow ==
                                                              "mbfacta_recovery"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban_mbfacta
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow ==
                                                            "agileenergy"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.iban_agileenergy
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Cessionario/prestatore (fornitore)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v("10134260966")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            "AGILE ENERGY S.r.l."
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Sede Legale: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "Piazza della Repubblica 9 20121 Milano (MI)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "info@agileenergy.it"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "(+39) 02 3056 6476"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("IBAN:  "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.iban_agileenergy
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("b", [
                                                          _vm._v(
                                                            "Installatore in subappalto"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .partita_iva
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .azienda
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Indirizzo: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .indirizzo
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .civico
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .cap
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .comune
                                                              ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .provincia
                                                              ) +
                                                              ")"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .email
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .cellulare
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm.getProfile.logo &&
                                                  _vm.flow != "agileenergy"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "50%!important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.getProfile.logo
                                                        }
                                                      })
                                                    : _vm.flow == "agileenergy"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "100%!important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            "https://storage.googleapis.com/chebonus/agileenergy/LOGOF.png"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Benificiario/committente (cliente)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Denominazione: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.clientName) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.clientLastname
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Indirizzo: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.adress) +
                                                        " " +
                                                        _vm._s(_vm.civic)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Comune: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.city.city) +
                                                        " (" +
                                                        _vm._s(_vm.province) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("CAP: "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.zip))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.client_email)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_phone
                                                    ? _c("span", [
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_phone
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_mobile
                                                    ? _c("span", [
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_mobile
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.flow != "mbfacta_recovery"
                                        ? _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left pt-4 h0 black"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("Il tuo Preventivo:")
                                              ])
                                            ]
                                          )
                                        : _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left pt-4 h0 black"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("La tua Pratica:")
                                              ])
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario == "si" &&
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89 della Legge n. 190/2014,\r\n                  così come modificato dalla Legge numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\r\n                "
                                              )
                                            ]
                                          )
                                        : _vm.client_type == "Partita IVA" &&
                                          _vm.iva_age_lavoro == "0.00" &&
                                          _vm.iva_age_extra == "0.00"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  Operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\r\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          ref: "invoiceData_part1",
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead"),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Beni significativi"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Importo unitario ")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.products, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(item.price) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm.totalProducts
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Agevolabile Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.totalProducts
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) -
                                                                parseFloat(
                                                                  _vm.totalExtraMise
                                                                )
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Altri beni ed accessori"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Importo unitario ")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.accessories, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(item.price) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", {
                                                  attrs: { scope: "row" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm.priceWork
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v("Totale "),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(
                                                          " altri beni ed accessori "
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.totalAccessories
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                                parseFloat(
                                                                  _vm.priceWork
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                )
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.dl == "new"
                                        ? _c(
                                            "table",
                                            {
                                              ref: "invoiceData_part2",
                                              staticClass:
                                                "table table-bordered "
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Altri oneri agevolabili"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Visto di conformità "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .vistoCost
                                                                    )
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Asseverazione della congruità delle spese "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.getProfile
                                                        .reg_forfettario !=
                                                        "si" ||
                                                      _vm.flow == "agileenergy"
                                                        ? _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm.priceAT
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        _vm.priceAT
                                                                      )
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "right" }
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v("Totale "),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                            "si" ||
                                                          _vm.flow ==
                                                            "agileenergy"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(
                                                            " altri oneri agevolabili "
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "right" }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  _vm.priceAT
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.calcInfo
                                                                      .vistoCost
                                                                  )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part3",
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v("Totale "),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    "imponibile"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(
                                                              " intervento "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "220",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  parseFloat(
                                                                    _vm.calcInfo
                                                                      .totalBase
                                                                  ) +
                                                                    parseFloat(
                                                                      _vm.priceAT
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .vistoCost
                                                                    )
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si" ||
                                      _vm.flow == "agileenergy"
                                        ? _c(
                                            "table",
                                            {
                                              ref: "invoiceData_part4",
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [_vm._v("Riepilogo")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", {
                                                    attrs: {
                                                      align: "left",
                                                      scope: "row"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm._v("Importo "),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                            "si" ||
                                                          _vm.flow ==
                                                            "agileenergy"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Aliquota IVA")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Totale (IVA Inclusa)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Beni significativi, quota concorrente accessori e manodopera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(_vm.age_lavoro)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  parseFloat(
                                                                    _vm.age_lavoro
                                                                  ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_age_lavoro
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Beni significativi, quota eccedente accessori e manodopera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(_vm.age_extra)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_extra *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  parseFloat(
                                                                    _vm.age_extra
                                                                  ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_age_extra
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  _vm.totalAccessories
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.priceWork
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_accessori_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  (parseFloat(
                                                                    _vm.totalAccessories
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  ) +
                                                                    parseFloat(
                                                                      _vm.priceWork
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    )) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_accessori_lavoro
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            "\r\n                        "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Altri oneri agevolabili"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    parseFloat(
                                                                      _vm.priceAT
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                      parseFloat(
                                                                        _vm
                                                                          .calcInfo
                                                                          .vistoCost
                                                                      )
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.iva_altri_oneri *
                                                                  100
                                                              ) + " %"
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    (
                                                                      (parseFloat(
                                                                        _vm.priceAT
                                                                          .replace(
                                                                            ".",
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            ",",
                                                                            "."
                                                                          )
                                                                      ) +
                                                                        parseFloat(
                                                                          _vm
                                                                            .calcInfo
                                                                            .vistoCost
                                                                        )) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        ))
                                                                    ).toFixed(2)
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part5",
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale quota Spesa agevolabile "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    "(IVA INCLUSA)"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  _vm.calcInfo
                                                                    .totalBaseAndIva
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          ref: "invoiceData_part6",
                                          staticClass: "table table-bordered "
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "uppercase",
                                                  attrs: {
                                                    colspan: "2",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Sconto in fattura " +
                                                      _vm._s(this.ecoBonus) +
                                                      " "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        this.client_type ==
                                                          "Partita IVA" &&
                                                        this.usoAbitativo ==
                                                          0 &&
                                                        this.iva_age_lavoro ==
                                                          "0.22" &&
                                                        this.iva_age_extra ==
                                                          "0.22" &&
                                                        this
                                                          .iva_accessori_lavoro ==
                                                          "0.22"
                                                          ? void 0
                                                          : [
                                                              _vm._v(
                                                                " (IVA INCLUSA)"
                                                              )
                                                            ]
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (Art. 121, D.L. 34/20 convertito con Legge 17 luglio 2020) "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalWithBonus
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale fattura al committente per bonifico  "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus ==
                                                          "Bonus Casa 50%" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (Art. 16 bis, D.P.R. 917/86)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (Art. 1, Legge 296/2006 e art. 14 D.L. 63/2013)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .totalBaseAndIva
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .totalWithBonus
                                                                )
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Altri oneri per il committente"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "2",
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Quota spesa non agevolata "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            !_vm.NoEnea
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Costo Gestione Pratica ENEA "
                                                      ),
                                                      _vm.getProfile
                                                        .reg_forfettario !=
                                                        "si" ||
                                                      _vm.flow == "agileenergy"
                                                        ? [
                                                            _vm._v(
                                                              "(IVA " +
                                                                _vm._s(
                                                                  _vm.iva_altri_oneri *
                                                                    100
                                                                ) +
                                                                " % INCLUSA)"
                                                            )
                                                          ]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _vm.flow != "agileenergy"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check hideOnPdf"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.zeroEnea,
                                                                    expression:
                                                                      "zeroEnea"
                                                                  }
                                                                ],
                                                                key: "1111",
                                                                staticClass:
                                                                  "form-check-input",
                                                                attrs: {
                                                                  type:
                                                                    "checkbox",
                                                                  id: "zeroEnea"
                                                                },
                                                                domProps: {
                                                                  checked: Array.isArray(
                                                                    _vm.zeroEnea
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.zeroEnea,
                                                                        null
                                                                      ) > -1
                                                                    : _vm.zeroEnea
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm.zeroEnea,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = null,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          (_vm.zeroEnea = $$a.concat(
                                                                            [
                                                                              $$v
                                                                            ]
                                                                          ))
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          (_vm.zeroEnea = $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            ))
                                                                      }
                                                                    } else {
                                                                      _vm.zeroEnea = $$c
                                                                    }
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  attrs: {
                                                                    for:
                                                                      "zeroEnea"
                                                                  }
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      "Escludi questa voce dal preventivo"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                    (1 +
                                                                      parseFloat(
                                                                        _vm.iva_altri_oneri
                                                                      ))
                                                                  ).toFixed(2)
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  parseFloat(
                                                                    _vm.priceEnea
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  ).toFixed(2)
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Costo Recupero Visura Catastale "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroDcast,
                                                                expression:
                                                                  "zeroDcast"
                                                              }
                                                            ],
                                                            key: "2311",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroDcast"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroDcast
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroDcast,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroDcast
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroDcast,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroDcast = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroDcast = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroDcast = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for: "zeroDcast"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.getProfile.reg_forfettario !=
                                                "si" ||
                                              _vm.flow == "agileenergy"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              (
                                                                parseFloat(
                                                                  _vm.priceDcast
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                              ).toFixed(2)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ).toFixed(2)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          " Oneri di Gestione Agile Energy "
                                                        )
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          " Oneri Finanziari "
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  _vm.flow == "cdp"
                                                    ? [_vm._v(" CDP ")]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "poste"
                                                    ? [
                                                        _vm._v(
                                                          " Poste Italiane "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "general"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso Base " +
                                                            _vm._s(
                                                              (
                                                                100 -
                                                                parseFloat(
                                                                  this.fin_cost
                                                                )
                                                              ).toFixed(2)
                                                            ) +
                                                            "%  "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "mbfacta"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso MBFACTA "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "mbfacta_recovery"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso Personalizzato "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [_vm._v("(IVA ESENTE)")]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroOneri,
                                                                expression:
                                                                  "zeroOneri"
                                                              }
                                                            ],
                                                            key: "2222",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroOneri"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroOneri
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroOneri,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroOneri
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroOneri,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroOneri = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroOneri = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroOneri = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for: "zeroOneri"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .allOneri
                                                            ) -
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Costo di gestione pratica "
                                                  ),
                                                  _vm.dl == "new"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " e Due Diligence "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroPratica,
                                                                expression:
                                                                  "zeroPratica"
                                                              }
                                                            ],
                                                            key: "3333",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroPratica"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroPratica
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroPratica,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroPratica
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroPratica,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroPratica = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroPratica = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroPratica = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for:
                                                                  "zeroPratica"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale altri oneri per il committente "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA " +
                                                                  _vm._s(
                                                                    _vm.iva_altri_oneri *
                                                                      100
                                                                  ) +
                                                                  " % INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario !=
                                                      "si" ||
                                                    _vm.flow == "agileenergy"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "\r\n                          €\r\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\r\n                        "
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            "\r\n                          €\r\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\r\n                        "
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part7",
                                          staticClass: "row ml-0 mr-0  pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale Importo € "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " ( a carico dell’utente finale "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    ", IVA inclusa"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" )")
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  _vm.calcInfo
                                                                    .finalPrice
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mb-0 mt-3 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm.getProfile
                                                          .reg_forfettario ==
                                                          "si" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                " Operazione in franchigia da Iva ex art. 1 cc. 54-89 L. 190/2014 "
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\r\n\r\n                          L’utilizzo dei servizi descritti sul Sito comporta l’integrale accettazione dei\r\n\r\n                          "
                                                        ),
                                                        _vm.brand == "CHEBONUS"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\r\n                            Termini e delle condizioni di riferimento ( https://chebonus.it/Conditions.pdf )\r\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\r\n                            Termini e delle condizioni di riferimento ( https://happybonus.it/Conditions.pdf )\r\n                          "
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "widthFull mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center"
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered "
                                          },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      "\r\n                          IMPORTO TOTALE DEL CREDITO CEDUTO\r\n                          "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.calcInfo
                                                                .totalWithBonus
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12 mb-3 " },
                                          [
                                            _vm._v(
                                              "\r\n                    L’aliquota degli oneri di attualizzazione dei crediti d’imposta relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110%\r\n                    indicata nel presente Preventivo è puramente indicativa e aggiornata al giorno precedente all’elaborazione del Preventivo.\r\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "Prima di far sottoscrivere al tuo cliente il Preventivo, ti invitiamo a verificare l’aliquota aggiornata degli oneri di\r\n                    attualizzazione dei crediti d’imposta dei Cessionari.\r\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\r\n                    Non si ritengono responsabili Novatag, Vaillant Group Italia e Società terze per eventuali danni\r\n                    economici derivanti dall’omissione della verifica da parte dell’installatore dell’aliquota aggiornata degli oneri di attualizzazione\r\n                    dei crediti d’imposta dei Cessionari e omissioni o errate valorizzazioni di tale Preventivo.\r\n\r\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _vm._v(
        "\r\n              Il Preventivo verrà generato a nome di Agile Energy con l'indicazione della tua ragione sociale come esecutore dei lavori in subappalto.\r\n              "
      ),
      _c("br"),
      _vm._v(
        "Prima di essere inviato al Cliente Finale (Committente) sarà oggetto di verifica interna per approvazione da parte di Agile Energy.\r\n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42d13b52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d13b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editCalc/index.vue
// module id = null
// module chunks = 